<template>
    <div class="content">
      <table class="company-table">
        <thead>
          <tr>
            <th>Маршрут</th>
            <th>Ставка без НДС</th>
            <th>Ставка с НДС</th>
            <th>Удаление маршрута</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="route in Data" :key="route.id">
            <td>{{ route.route }}</td>
            <td><input class="number-input" v-model="route.bid" type="number" @input="updateRoute(route)"/></td>
            <td class="rate-sum">
              <input class="number-input" v-model="route.bid_tax" type="number" @input="updateRoute(route)"/>
            </td>
            <td><button class="delete-button hover" @click="deleteRoute(route.id)" >Удалить</button></td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
  
  <script>
  import { ref,computed } from 'vue';
  
  export default {
    props: ['Data'],
    setup(_, { emit }) {
      const search = ref('');

      const deleteRoute = (id) =>{
        emit('deleteRoute', id);
      }

      const updateRoute = (route) =>{
        if(route.bid && route.bid_tax) {
          route.changed = true
        }
        else if(route.changed){
          route.changed = false
        }
      }
  
      return {
        updateRoute,
        deleteRoute,
        search,
      };
    },
  }
  </script>
  
  <style scoped>
  .company-table {
    margin-right: 20px;
    border-collapse: collapse;
  }
  
  .company-table th {
    text-align: center;
    padding: 10px;
    border: 1px solid #ccc;
  }
  
  .company-table td {
    text-align: center;
    padding: 3px;
    font-size: 12px;
    border: 1px solid #ccc;
  }

  .company-table th {
    font-weight: bold;
  }
  
  .rate-sum{
    min-width: 100px;
  }

  .number-input {
    width: 65px;
  }

  .delete-button{
    padding: 2px;
    border-radius: 4px;
    border: 1px solid #ccc;
  }

  .hover:hover {
    cursor: pointer;
  }
  </style>
  